import { Fragment, useState, useEffect, useContext } from "react";
import { AiOutlineDownload } from "react-icons/ai";

import TablaResumen from "./componenteBalance/TablaResumen";
import TablaBalance from "./componenteBalance/TablaBalance";
import GraficoTorta from "./componenteBalance/GraficoTorta";

import clienteAxios from "../../config/axios";
import { CRMContext } from "../context/CRMContext";


function IngresoAño({ pdfcrear,cambioActivo }) {
    const [ auth, guardarAuth ] = useContext(CRMContext);

    const [ años, guardarAños ] = useState([]);
    const meses = [
        'Enero',
        'Febrero',
        'Marzo',
        'Abril',
        'Mayo',
        'Junio',
        'Julio',
        'Agosto',
        'Septiembre',
        'Octubre',
        'Noviembre',
        'Diciembre',
    ];

    const [ fechaPrimero, guardarFechaPrimero ] = useState({
        año: 0
    });

    const [ facturaPrimero, guardarFacturaPrimero ] = useState([]);
    const [ totalMes, guardarTotalMes ] = useState([]);
    const [ totalPrimero, guardarTotalPrimero ] = useState(0);

    const [ infoGrafico, guardarInfoGrafico ] = useState([]);

    // guarda año y mes de la segunda
    const guardarPrimero = (e) => {
        guardarFechaPrimero({
            ...fechaPrimero,
            [e.target.name]: parseInt(e.target.value)
        });
    }    

    //  Obtiene info de la primera fecha
    const consultarPrimero = async (fecha) => {
        
        const res = await clienteAxios.post('/factura/balance/ingreso/mes', fecha,{
            headers: {
                Authorization: `Bearer ${auth.token}`
            }
        });

        let resultado = 0;

        res.data.forEach(data => {
            resultado += ( data?.monto + (data?.monto * .19) );
        });

        return { data: res.data, resultado };
    } 

    // todos los años de registro
    const obtenerAños = () => {

        const añoActual = new Date().getFullYear();

        let inicio = 2022;

        const guardado = [];
        
        while(inicio <= añoActual) {

            guardado.push(inicio);

            inicio += 1;

        }

        guardarAños(guardado)
    }

    // obtiene factura anual
    const obtnerFacturaAnual = async () => {

        try {
            
            const facturaAño = [];
            const totalMes = [];
            const info = [];
            
            const enero = await consultarPrimero({mes: 1, año: fechaPrimero.año});
            facturaAño.push(enero.data);
            totalMes.push(enero.resultado);
            info.push({ name:'Enero', value: enero.resultado });
            
            const febrero = await consultarPrimero({mes: 2, año: fechaPrimero.año});
            facturaAño.push(febrero.data);
            totalMes.push(febrero.resultado);
            info.push({ name:'Febrero', value: febrero.resultado });
            
            const marzo = await consultarPrimero({mes: 3, año: fechaPrimero.año});
            facturaAño.push(marzo.data);
            totalMes.push(marzo.resultado);
            info.push({ name:'Marzo', value: marzo.resultado });
            
            const abril = await consultarPrimero({mes: 4, año: fechaPrimero.año});
            facturaAño.push(abril.data);
            totalMes.push(abril.resultado);
            info.push({ name:'Abril', value: abril.resultado });
            
            const mayo = await consultarPrimero({mes: 5, año: fechaPrimero.año});
            facturaAño.push(mayo.data);
            totalMes.push(mayo.resultado);
            info.push({ name:'Mayo', value: mayo.resultado });
            
            const junio = await consultarPrimero({mes: 6, año: fechaPrimero.año});
            facturaAño.push(junio.data);
            totalMes.push(junio.resultado);
            info.push({ name:'Junio', value: junio.resultado });
            
            const julio = await consultarPrimero({mes: 7, año: fechaPrimero.año});
            facturaAño.push(julio.data);
            totalMes.push(julio.resultado);
            info.push({ name:'Julio', value: julio.resultado });
            
            const agosto = await consultarPrimero({mes: 8, año: fechaPrimero.año});
            facturaAño.push(agosto.data);
            totalMes.push(agosto.resultado);
            info.push({ name:'Agosto', value: agosto.resultado });
            
            const septiembre = await consultarPrimero({mes: 9, año: fechaPrimero.año});
            facturaAño.push(septiembre.data);
            totalMes.push(septiembre.resultado);
            info.push({ name:'Septiembre', value: septiembre.resultado });
            
            const octubre = await consultarPrimero({mes: 10, año: fechaPrimero.año});
            facturaAño.push(octubre.data);
            totalMes.push(octubre.resultado);
            info.push({ name:'Octubre', value: octubre.resultado });
            
            const noviembre = await consultarPrimero({mes: 11, año: fechaPrimero.año});
            facturaAño.push(noviembre.data);
            totalMes.push(noviembre.resultado);
            info.push({ name:'Noviembre', value: noviembre.resultado });
            
            const diciembre = await consultarPrimero({mes: 12, año: fechaPrimero.año});
            facturaAño.push(diciembre.data);
            totalMes.push(diciembre.resultado);
            info.push({ name:'Diciembre', value: diciembre.resultado });
            
            guardarTotalMes(totalMes);
            guardarFacturaPrimero(facturaAño);
            guardarInfoGrafico(info);

            let total = 0;

            totalMes.forEach(data => {
                total += data;
            });

            guardarTotalPrimero(total);

        } catch (error) {
            console.log(error);
        }

    }

    const descargar = () => {
        cambioActivo();
        pdfcrear(`Balance Ingreso ${fechaPrimero.año}`, "#ingresoAño", "a2", "portrait");
    }

    useEffect(() => {
        obtenerAños();

        if ( fechaPrimero.año !== 0 ){
            obtnerFacturaAnual();
        }

    },[fechaPrimero]);
    return (
        <Fragment>

            <div 
                id="btnCrearPdf" 
                className='btn-new btn-login' 
                onClick={descargar}
            >
                Descargar Balance Ingreso Año
                <AiOutlineDownload size={25} />
            </div>

            <h2 className='card-body-subtitle'>Ingreso por Año</h2>

            <form onSubmit={e => e.preventDefault()}>
                <div className='campo'>
                    <label htmlFor="año">Seleccione Año:</label>
                    <select name="año" id="año" defaultValue={fechaPrimero.año} onChange={guardarPrimero} >
                        <option value={0} disabled> -- Seleccione -- </option>    
                        {
                            años.length !== 0 ?
                                años.map(año => (
                                    <option value={año} key={año} > {año} </option>
                                ))
                            :
                            null
                        }
                    </select>         
                </div>
            </form>

            <div id="ingresoAño" >
                {
                    facturaPrimero.length > 0 ?
                        <Fragment>

                            <TablaResumen meses={meses} data={totalMes} año={fechaPrimero.año} total={totalPrimero} tipo={'Ingreso'} />

                            <GraficoTorta
                                data={infoGrafico}
                            />

                            <div className="balance_tablas">
                                <div>
                                    <h2 className='card-body-subtitle'>
                                        Ingreso {meses[0]} de {fechaPrimero.año} 
                                    </h2>
                                    <TablaBalance data={facturaPrimero[0]} total={totalMes[0]} />
                                </div>
                                <div>
                                    <h2 className='card-body-subtitle'>
                                        Ingreso {meses[1]} de {fechaPrimero.año} 
                                    </h2>
                                    <TablaBalance data={facturaPrimero[1]} total={totalMes[1]} />
                                </div>
                            </div>

                            <div className="balance_tablas">
                                <div>
                                    <h2 className='card-body-subtitle'>
                                        Ingreso {meses[2]} de {fechaPrimero.año} 
                                    </h2>
                                    <TablaBalance data={facturaPrimero[2]} total={totalMes[2]} />
                                </div>
                                <div>
                                    <h2 className='card-body-subtitle'>
                                        Ingreso {meses[3]} de {fechaPrimero.año} 
                                    </h2>
                                    <TablaBalance data={facturaPrimero[3]} total={totalMes[3]} />
                                </div>
                            </div>

                            <div className="balance_tablas">
                                <div>
                                    <h2 className='card-body-subtitle'>
                                        Ingreso {meses[4]} de {fechaPrimero.año} 
                                    </h2>
                                    <TablaBalance data={facturaPrimero[4]} total={totalMes[4]} />
                                </div>
                                <div>
                                    <h2 className='card-body-subtitle'>
                                        Ingreso {meses[5]} de {fechaPrimero.año} 
                                    </h2>
                                    <TablaBalance data={facturaPrimero[5]} total={totalMes[5]} />
                                </div>
                            </div>

                            <div className="balance_tablas">
                                <div>
                                    <h2 className='card-body-subtitle'>
                                        Ingreso {meses[6]} de {fechaPrimero.año} 
                                    </h2>
                                    <TablaBalance data={facturaPrimero[6]} total={totalMes[6]} />
                                </div>
                                <div>
                                    <h2 className='card-body-subtitle'>
                                        Ingreso {meses[7]} de {fechaPrimero.año} 
                                    </h2>
                                    <TablaBalance data={facturaPrimero[7]} total={totalMes[7]} />
                                </div>
                            </div>

                            <div className="balance_tablas">
                                <div>
                                    <h2 className='card-body-subtitle'>
                                        Ingreso {meses[8]} de {fechaPrimero.año} 
                                    </h2>
                                    <TablaBalance data={facturaPrimero[8]} total={totalMes[8]} />
                                </div>
                                <div>
                                    <h2 className='card-body-subtitle'>
                                        Ingreso {meses[9]} de {fechaPrimero.año} 
                                    </h2>
                                    <TablaBalance data={facturaPrimero[9]} total={totalMes[9]} />
                                </div>
                            </div>

                            <div className="balance_tablas">
                                <div>
                                    <h2 className='card-body-subtitle'>
                                        Ingreso {meses[10]} de {fechaPrimero.año} 
                                    </h2>
                                    <TablaBalance data={facturaPrimero[10]} total={totalMes[10]} />
                                </div>
                                <div>
                                    <h2 className='card-body-subtitle'>
                                        Ingreso {meses[11]} de {fechaPrimero.año} 
                                    </h2>
                                    <TablaBalance data={facturaPrimero[11]} total={totalMes[11]} />
                                </div>
                            </div>

                        </Fragment>
                    :
                        null
                }
            </div>

        </Fragment>
    )
}

export default IngresoAño;